import { Card, CommandButton } from "components"
import { Fragment, useEffect, useState } from "react"
import { useList } from "./hooks"
import { FilterSection, TableSection } from "./components"
import { SelectedState } from "pages/FindSection/types"

export function FindByInventory() {
  const [selected, setSelected] = useState<SelectedState>({ date_from: "", date_end: "", search_by: "", search_id: "" })
  const { data, isLoading, refetch } = useList()

  useEffect(() => {
    const filteredSelected: Partial<SelectedState> = {};

    (Object.keys(selected) as Array<keyof SelectedState>).forEach(key => {
      if (selected[key]) { filteredSelected[key] = selected[key] }
    });

    refetch(filteredSelected);

    // eslint-disable-next-line
  }, [selected])

  return (
    <Fragment>
      <FilterSection selected={selected} setSelected={setSelected} />

      <section className="mt-2">
        <Card>
          <Card.Body>
            <TableSection data={data} isLoading={isLoading} refetch={refetch} selected={selected} />
          </Card.Body>
        </Card>
      </section>

      <section className="mt-2">
        <Card>
          <Card.Body className="flex flex-col gap-5">
            <section className="flex flex-wrap justify-between items-center gap-3">
              <section className="flex flex-wrap gap-3">
                <CommandButton actiontype="help" />
                <CommandButton actiontype="print" />
                <CommandButton actiontype="email" />
                <CommandButton actiontype="export" />
              </section>
            </section>
          </Card.Body>
        </Card>
      </section>
    </Fragment>
  )
}
